import { render, staticRenderFns } from "./search-forms.vue?vue&type=template&id=3d58844b&scoped=true&"
import script from "./search-forms.vue?vue&type=script&lang=js&"
export * from "./search-forms.vue?vue&type=script&lang=js&"
import style0 from "./search-forms.vue?vue&type=style&index=0&id=3d58844b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d58844b",
  null
  
)

export default component.exports